import { render } from "./PaginationControls.vue?vue&type=template&id=b2e2ef04&scoped=true"
import script from "./PaginationControls.vue?vue&type=script&lang=js"
export * from "./PaginationControls.vue?vue&type=script&lang=js"

import "./PaginationControls.vue?vue&type=style&index=0&id=b2e2ef04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e2ef04"]])

export default __exports__